jQuery(document).ready(function () {
    jQuery(".ScrollToSecBtn").click(function (e) {
        let getHref = jQuery(this).attr("href");
        if ((!getHref) || (getHref == "#")) {
            e.preventDefault();
            let headerHeight = $("header").outerHeight();
            let setSecOffset = $('.featured_product_view').offset().top - headerHeight;
            jQuery('html, body').animate({
                scrollTop: setSecOffset
            }, 500);
        }
    });
});